import { render, staticRenderFns } from "./BasicFieldOutcomes.vue?vue&type=template&id=145b4573&scoped=true"
import script from "./BasicFieldOutcomes.vue?vue&type=script&lang=js"
export * from "./BasicFieldOutcomes.vue?vue&type=script&lang=js"
import style0 from "./BasicFieldOutcomes.vue?vue&type=style&index=0&id=145b4573&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145b4573",
  null
  
)

export default component.exports